if (!customElements.get('movitamins-knowledge')) {
  customElements.define(
    'movitamins-knowledge',
    class MovitaminsKnowledge extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.onTabClick = this.handleTabClick.bind(this);
        this.onTabKeydown = this.handleTabKeydown.bind(this);
        this.onBlockSelect = this.handleBlockSelect.bind(this);

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', this.onTabClick);
          tab.addEventListener('keydown', this.onTabKeydown);
        });
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        if (this.tabs.length > 1) {
          const selected = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
          this.select(selected, false);
          this.dataset.jsReady = 'true';
        }
      }

      disconnectedCallback() {
        if (!this.initialized) return;
        this.tabs.forEach((tab) => {
          tab.removeEventListener('click', this.onTabClick);
          tab.removeEventListener('keydown', this.onTabKeydown);
        });
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.initialized = false;
      }

      handleTabClick(event) {
        this.select(event.currentTarget, true);
      }

      handleTabKeydown(event) {
        const index = this.tabs.indexOf(event.currentTarget);
        const destinations = {
          ArrowLeft: index - 1,
          ArrowRight: index + 1,
          Home: 0,
          End: this.tabs.length - 1,
        };
        if (!(event.key in destinations)) return;
        event.preventDefault();
        const next = this.tabs[(destinations[event.key] + this.tabs.length) % this.tabs.length];
        this.select(next, true);
        next.focus();
      }

      handleBlockSelect(event) {
        if (event.detail?.sectionId !== this.dataset.sectionId) return;
        const lecturePanel = this.querySelector('[data-knowledge-panel="lectures"]');
        const lectureTab = this.querySelector('[data-knowledge-tab="lectures"]');
        if (lecturePanel && lectureTab) this.select(lectureTab, false);
      }

      select(tab, focus) {
        const panelId = tab.getAttribute('aria-controls');
        this.tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== panelId;
        });
        if (focus) tab.focus();
      }
    }
  );
}
